import Feedback from './Feedback'

export default Feedback



// WEBPACK FOOTER //
// ./src/containers/Modals/Feedback/index.js